import axios from 'axios'
import { auth } from '@/lib/firebase'
import { env } from './env'

// getIdToken() refreshes an expired token, so a tab left open for hours keeps working.
export const api = axios.create({ baseURL: `${env.apiBaseUrl}/api/v1/admin` })

api.interceptors.request.use(async (config) => {
  const user = auth.currentUser
  if (user) config.headers.Authorization = `Bearer ${await user.getIdToken()}`
  return config
})

/** The message the API sent, or a plain fallback. */
export function errorMessage(err: unknown): string {
  if (axios.isAxiosError(err)) {
    if (err.response?.data?.message) return String(err.response.data.message)
    if (!err.response) return 'The API did not answer. Check that it is running.'
    return `The API answered ${err.response.status}.`
  }
  return err instanceof Error ? err.message : 'Something went wrong.'
}

export const isForbidden = (err: unknown) => axios.isAxiosError(err) && err.response?.status === 403

/**
 * Signs you in as that user in the customer app, in a new tab. The tab is opened
 * before the request so the browser doesn't take it for a popup; the token goes in
 * the URL fragment, which is never sent to a server.
 */
export async function impersonate(uid: string): Promise<void> {
  const tab = window.open('', '_blank')
  try {
    const { data } = await api.post<{ token: string }>(`/users/${encodeURIComponent(uid)}/impersonate`)
    const url = `${env.customerAppUrl}/impersonate#token=${encodeURIComponent(data.token)}`
    if (tab) {
      tab.opener = null
      tab.location.href = url
    } else {
      window.location.href = url
    }
  } catch (err) {
    tab?.close()
    throw err
  }
}
